<template>
  <div class="hello">Top Page</div>
</template>

<script>
export default {
  name: 'Top',
};
</script>



// WEBPACK FOOTER //
// src/components/Top.vue